// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"346":"32564227","763":"4fe332dd","775":"5287b867","972":"a4a6e655"}[chunkId] + ".chunk.js";
};